import React from 'react'

export default function DownArrowSvg({fill, className = ''}) {
  return (
    <svg x="0" y="0" viewBox="0 0 500 292.4" fill={fill} className={className}>
      <path d="M41 1l208 207L457 0l43 43-249 249L0 42z" />
    </svg>
  )
}
